function sanitizeFilename(value) {
  if (!value) return null;
  const decoded = value.trim();
  const basename = decoded.split(/[\\/]/).pop();
  return basename || null;
}

export function filenameFromContentDisposition(value) {
  if (!value) return null;

  const utf8Match = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return sanitizeFilename(decodeURIComponent(utf8Match[1].trim()));
    } catch {
      return sanitizeFilename(utf8Match[1]);
    }
  }

  const filenameMatch = value.match(/filename="?([^";]+)"?/i);
  return filenameMatch ? sanitizeFilename(filenameMatch[1]) : null;
}

export function downloadBlobResponse(response, fallbackFilename = 'export') {
  const contentType = response?.headers?.['content-type'] || 'application/octet-stream';
  const contentDisposition = response?.headers?.['content-disposition'];
  const filename = filenameFromContentDisposition(contentDisposition) || fallbackFilename;
  const blob = response?.data instanceof Blob
    ? response.data
    : new Blob([response?.data ?? ''], { type: contentType });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
